export default __webpack_public_path__ + "static/LUTEIN-EYE-LOUPE-5eb76559c4da3e292d243864d896c0c2.jpg";